/* eslint-disable */ 
import React from 'react';
import './components.css';

export default (props) => {
	const {
		cancel,
		cancelButtonText,
		submit,
		submitButtonText,
		elements,
	} = props;

	function handleSubmit(event) {
		event.preventDefault();
		submit();
	}

	function handleCancel(event) {
		event.preventDefault();
		cancel();
	}

  return (
		<div>
			<form onSubmit={handleSubmit}>
				<div className="space-y-4">
					{elements()}
					<div className="mt-4 flex items-center gap-3">
						<input className="btn-2025 btn-2025-primary" type="submit" value={submitButtonText} />
						<button className="btn-2025" onClick={handleCancel}>{cancelButtonText}</button>
					</div>
				</div>
			</form>
		</div>
  );
}